<template>
  <div>
    <Editor id="tinymce" v-model="value" :init="editorInit"></Editor>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/modern/theme'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import Axios from "axios";
const config = require('../../../config')
export default {
  watch: {
    value: function(val) {
      sessionStorage.setItem('valEditor',val)
    }
  },
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editorInit: {
        selector: "#tinydemo4",
        convert_urls: false,
        // relative_urls:false,
        // remove_script_host:false,
        language_url: "/static/tinymce/zh_CN.js",
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/lightgray",
        height: 300,
        menu: {
          file: { title: "File", items: "newdocument" },
          edit: {
            title: "Edit",
            items: "undo redo | cut copy paste pastetext | selectall"
          },
          insert: { title: "Insert", items: "link media | template hr" },
          view: { title: "View", items: "visualaid" },
          format: {
            title: "Format",
            items:
              "bold italic underline strikethrough superscript subscript | formats | removeformat"
          },
          table: {
            title: "Table",
            items: "inserttable tableprops deletetable | cell row column"
          }
        },
        automatic_uploads:false,
        target_list:[
          {title: '当前窗口', value: ''},
          {title: '新窗口', value: '_blank'},
        ],
        file_picker_callback: function(callback, value, meta) {
          console.log(this.language_url, "callback, value, meta");
          //文件分类
          var filetype =
            ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.png,.gif,.bmp,.jpeg,.rar,.zip,.7z";
          //后端接收上传文件的地址
          var upurl = "/api/informationPublic/saveFile";
          //为不同插件指定文件类型及后端地址
          switch (meta.filetype) {
            case "image":
              filetype = ".jpg, .jpeg, .png, .gif";
              upurl = "/api/informationPublic/saveFile";
              break;
            case "media":
              filetype = ".mp3, .mp4";
              upurl = "/api/informationPublic/saveFile";
              break;
            case "file":
              upurl = "/api/informationPublic/saveFile";
            default:
          }
          //模拟出一个input用于添加本地文件
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", filetype);
          input.click();
          let that = this;
          input.onchange = function(e) {
            let data = new FormData();
            data.append("file", this.files[0]);
            let config = {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            };
            Axios.post(upurl, data, config).then(res => {
              console.log(res,'url--=====')
              sessionStorage.setItem('value',res.data.url)
              callback(res.data.url,{text:""})
            });
          };
        },
        // plugins: [
        //   "lists  media table wordcount code fullscreen help codesample toc insertdatetime  searchreplace  link charmap paste hr",
        //   "fullpage autosave nonbreaking  visualchars visualblocks  pagebreak print preview  anchor"
        // ],
        plugins: 'link lists image code table colorpicker textcolor wordcount contextmenu',
        // toolbar: [
        //   "newdocument undo redo|formatselect visualaid| copy paste selectall| bold italic underline strikethrough |codeformat blockformats| superscript subscript  | forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent |  removeformat ",
        //   "code  bullist numlist|lists  media table |fullscreen help toc fullpage restoredraft nonbreaking insertdatetime visualchars visualblocks searchreplace pagebreak anchor charmap  pastetext print preview hr | link unlink uploadimage"
        // ],
        branding: false,
        images_upload_url: config.dev.proxyTable['/'].target,
        images_upload_handler: (blobInfo, success, failure) => {
          this.handleImgUpload(blobInfo, success, failure);
        }
      },
      imageObject: {
        token: "",
        key: "",
        file: ""
      },
      action: config.dev.proxyTable['/'].target,
      domian: config.dev.proxyTable['/'].target
    };
  },
  created() {
    // this.editorInit.file_picker_callback.bind(this);
  },
  methods: {
    async handleImgUpload(blobInfo, success, failure) {
      let _this = this;
      _this.imageObject.file = blobInfo;
      let res = await _this.beforUpload();
      _this.imageObject.token = res.token;
      _this.imageObject.key = res.key;
      let url =
        _this.editorInit.images_upload_url +
        "/" +
        _this.imageObject.key +
        "/" +
        blobInfo.filename();
      // console.log(_this.imageObject);
      Axios.post(url, blobInfo.base64(), {
        headers: {
          "Content-Type": "application/octet-stream",
          Authorization: "UpToken " + _this.imageObject.token
        }
      })
        .then(res => {
          success(_this.domian + res.data.key);
        })
        .catch(res => {
          failure("error");
        });
    },
    async beforUpload() {
      return new Promise((resolve, reject) => {
        Axios.get("/api/getToken")
          .then(response => {
            resolve(response.data);
          })
          .catch(() => {
            reject(false);
          });
      });
    }
  },
  components: {
    Editor
  },
  mounted() {
    tinymce.init({});
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Layout/editorInformation.vue